"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = chunkSpeakers;

var _Term = _interopRequireDefault(require("../Term"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Optimized function to chunk speaker term arrays using fullTurns metadata or fixed chunk sizes.
 * Handles large datasets efficiently.
 *
 * @param {Array} speakersArray - Array of speaker objects containing `value` (array of terms).
 * @param {number} chunkSize - Optional fixed chunk size in ms if fullTurns is not provided.
 * @param {Array} fullTurns - Optional array of {speaker, s, e} turns for exact segmentation.
 * @returns {Array} Chunked speaker segments.
 */
function chunkSpeakers(speakersArray, chunkSize, fullTurns) {
  if (chunkSize === void 0) {
    chunkSize = 12000;
  }

  if (fullTurns === void 0) {
    fullTurns = [];
  }

  if (!Array.isArray(speakersArray) || speakersArray.length === 0) return [];
  var hasFullTurns = Array.isArray(fullTurns) && fullTurns.length;
  var result = []; // Pre-index fullTurns by speaker to avoid repeated filtering

  var fullTurnsMap = hasFullTurns ? fullTurns.reduce(function (acc, turn) {
    var key = turn.speaker || 'Unknown';
    if (!acc[key]) acc[key] = [];
    acc[key].push(turn);
    return acc;
  }, {}) : null;

  for (var _iterator = _createForOfIteratorHelperLoose(speakersArray), _step; !(_step = _iterator()).done;) {
    var _speaker$get, _speaker$get2;

    var speaker = _step.value;
    var terms = speaker.value;
    if (!Array.isArray(terms) || terms.length === 0) continue;
    var speakerId = ((_speaker$get = speaker.get) === null || _speaker$get === void 0 ? void 0 : _speaker$get.call(speaker, 'i')) || ((_speaker$get2 = speaker.get) === null || _speaker$get2 === void 0 ? void 0 : _speaker$get2.call(speaker, 'speaker')) || 'Unknown';

    if (hasFullTurns) {
      var matchingTurns = [].concat(fullTurnsMap[speakerId] || [], speakerId !== 'Unknown' ? fullTurnsMap['Unknown'] || [] : []);

      for (var i = 0; i < matchingTurns.length; i++) {
        var _matchingTurns$i = matchingTurns[i],
            s = _matchingTurns$i.s,
            e = _matchingTurns$i.e; // Binary search-like approach for large sorted term arrays (assuming sorted)

        var chunkTerms = [];

        for (var j = 0; j < terms.length; j++) {
          var term = terms[j];

          if (term.start >= s && term.end <= e) {
            chunkTerms.push(term);
          }
        }

        if (chunkTerms.length === 0) continue;
        var newSpeaker = i === 0 ? speaker : new _Term["default"](speaker);
        newSpeaker.value = chunkTerms;

        if (typeof newSpeaker.freezeWords === 'function') {
          newSpeaker.freezeWords();
        }

        result.push(newSpeaker);
      }
    } else {
      // No fullTurns: fallback to chunkSize approach
      var startTime = terms[0].start;
      var chunksMap = new Map();

      for (var _iterator2 = _createForOfIteratorHelperLoose(terms), _step2; !(_step2 = _iterator2()).done;) {
        var _term = _step2.value;
        var index = Math.floor((_term.start - startTime) / chunkSize);
        if (!chunksMap.has(index)) chunksMap.set(index, []);
        chunksMap.get(index).push(_term);
      }

      var isFirst = true;

      for (var _iterator3 = _createForOfIteratorHelperLoose(chunksMap.values()), _step3; !(_step3 = _iterator3()).done;) {
        var chunk = _step3.value;

        var _newSpeaker = isFirst ? speaker : new _Term["default"](speaker);

        _newSpeaker.value = chunk;

        if (typeof _newSpeaker.freezeWords === 'function') {
          _newSpeaker.freezeWords();
        }

        result.push(_newSpeaker);
        isFirst = false;
      }
    }
  }

  return result;
}